export default __webpack_public_path__ + "static/media/telemed.59cbb8eb.svg";